<template>
  <BaseButtonIcon
    icon-name="vuesax:arrow-left"
    icon-size="20px"
    :size="props.size"
    :form="props.form"
    data-testid="open-back-navigation-btn"
    :shadow="props.shadow"
    @click="handleNavigateToBack"
  />
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

import { goToBack } from '../../lib/router'
import BaseButtonIcon from '../button-icon/index.vue'

interface Props {
  size?: 'xxxs' | 'xxs' | 'xs' | 'sm' | 'md' | 'md-alt' | 'lg'
  hasClickBack?: boolean
  fallbackRoute?: RouteLocationRaw
  form?: 'default' | 'circle'
  shadow?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
  form: 'circle',
  shadow: false,
})
const emit = defineEmits<{
  (e: 'click'): void
}>()

async function handleNavigateToBack() {
  if (props.hasClickBack) {
    emit('click')
    return
  }

  goToBack({
    fallback: props.fallbackRoute,
  })
}
</script>
